// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PoemController from "./poem_controller"
import RainController from "./rain_controller"
import SkyController  from "./sky_controller"
import TreeController from "./tree_controller"

application.register("poem", PoemController)
application.register("rain", RainController)
application.register("sky",  SkyController)
application.register("tree", TreeController)
